/**
 * @note This is specific to English.
 * @example joinList(['test']) //=> 'test'
 * @example joinList(['chimp', 'ape']) //=> 'chimp and ape'
 * @example joinList(['chimp', 'ape'], 'or') //=> 'chimp or ape'
 * @example joinList(['Mercury', 'Venus', 'Earth', 'Mars']) //=> 'Mercury, Venus, Earth, and Mars'
 */
export const joinList = (
  input: unknown[],
  final: string | undefined = 'and'
): string => {
  if (input.length === 0) return ''

  const finalMember = input.slice(-1)
  if (input.length === 1) return finalMember.toString()

  const rest = input.slice(0, -1)
  const joined = rest.join(', ')
  if (input.length === 2) return `${joined} ${final} ${finalMember}`

  return `${joined}, ${final} ${finalMember}`
}
